export default __webpack_public_path__ + "static/media/AOT.3f708322.png";